import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {ClearingScorecard} from "../../model/metrics/clearing-scorecard";
import {RecordResult} from "../../model/api/record-result";
import {ExchangeVolumePerDateTime} from "../../model/metrics/exchange-volume-per-date-time";

export class CrystalclearMetricsBackUrl{
  static readonly GET_CLEARING_STATUS_METRICS: CrystalclearBackUrl.UrlConf<RecordResult<ClearingScorecard>> = {
    url: '/api/metrics/clearing-status/list',
    type: RecordResult
  };

  static readonly GET_CLEARING_DATA_TREND_METRICS: CrystalclearBackUrl.UrlConf<RecordResult<ExchangeVolumePerDateTime>> = {
    url: '/api/metrics/data-trend/list',
    type: RecordResult
  };

}
